import script from "./MacronutrientChart.vue?vue&type=script&setup=true&lang=js"
export * from "./MacronutrientChart.vue?vue&type=script&setup=true&lang=js"

import "./MacronutrientChart.vue?vue&type=style&index=0&id=feec5d32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-feec5d32"]])

export default __exports__